"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var __1 = require("..");
var TournamentSignUpSuccessPage = /** @class */ (function (_super) {
    __extends(TournamentSignUpSuccessPage, _super);
    function TournamentSignUpSuccessPage(api, navigator) {
        var _this = _super.call(this, __1.PageTypes.TournamentSignUpSuccess, 'You\'re all signed up') || this;
        _this.api = api;
        _this.navigator = navigator;
        _this.goToHome = function () {
            _this.navigator.goToHome();
        };
        return _this;
    }
    return TournamentSignUpSuccessPage;
}(__1.BasePage));
exports.default = TournamentSignUpSuccessPage;
